import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-242fc060"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-progress-inner" }
const _hoisted_2 = { class: "circle" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom_arrow" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "m-progress-text"
}
const _hoisted_5 = {
  key: 1,
  class: "m-progress-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createBlock(_component_van_overlay, {
    class: "upload-progress",
    show: $setup.visible
  }, {
    default: _withCtx(() => [
      ($setup.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "m-progress-wrapper",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: "circle_left ab",
                  style: _normalizeStyle($setup.leftStyle)
                }, null, 4),
                _createElementVNode("div", {
                  class: "circle_right ab",
                  style: _normalizeStyle($setup.rightStyle)
                }, null, 4),
                _hoisted_3
              ]),
              ($setup.total && !$props.uploadErrorFlag)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "上传中（" + _toDisplayString($setup.doneNum || '') + "/" + _toDisplayString($setup.total || '') + "）...", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, "上传中...")),
              ($setup.doneNum < $setup.total || !$setup.total)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.cancelUpload && $setup.cancelUpload(...args))),
                    class: "m-cancel-btn"
                  }, "取消上传"))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["show"]))
}